/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Doesnotexistaspect4Inputs */

const de__class_doesnotexistaspect4 = /** @type {(inputs: _Class_Doesnotexistaspect4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`existiert nicht`)
};

/**

* @param {_Class_Doesnotexistaspect4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_doesnotexistaspect4 = /** @type {((inputs?: _Class_Doesnotexistaspect4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Doesnotexistaspect4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_doesnotexistaspect4(inputs)
});
export { _class_doesnotexistaspect4 as "_class_DoesNotExistAspect" }